"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const strings_1 = require("../../../constants/strings");
const uiConstants_1 = require("../../../constants/uiConstants");
const simpleButton_1 = __importDefault(require("../../atoms/button/simpleButton"));
const ConfirmMenu = ({ saveConfirmAside = () => ({}), closeConfirmAside = () => ({}), confirmDisabled = true, confirmButtonColor = uiConstants_1.UI_BUTTON_SECONDARY, confirmButtonName = strings_1.companySettingsTeamsStrings.YES_BUTTON_TEXT, cancelButtonName = strings_1.companySettingsTeamsStrings.CANCEL_BUTTON_TEXT, }) => {
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { style: { marginTop: 'auto' }, sx: {
            pt: 3,
            gap: 2,
        }, children: [saveConfirmAside ? ((0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: confirmButtonName, onClick: () => saveConfirmAside(), color: confirmButtonColor, disabled: confirmDisabled, label: confirmButtonName })) : (''), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: cancelButtonName, onClick: closeConfirmAside, color: uiConstants_1.UI_BUTTON_SECONDARY, label: cancelButtonName })] }));
};
exports.default = ConfirmMenu;
